export default __webpack_public_path__ + "static/media/patrimoine-à l'abandon.a1c9e621.svg";